import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourceModel } from '../models/resource.model';
import { inject } from '@angular/core';
import { CmcApiService } from './cmc-api.service';

export class ResourceService<T extends ResourceModel<T>> {
  protected readonly api = inject(CmcApiService);

  constructor(
    private httpClient: HttpClient,
    private tConstructor: { new (m: Partial<T>, ...args: unknown[]): T },
    protected apiUrl: string,
  ) {
  }


  public create(resource: Partial<T> & { toJson: () => T }): Observable<T> {
    return from(this.api
      .post('route-api', `${this.apiUrl}/`, {body: resource.toJson()}))
      .pipe(map((result) => new this.tConstructor(result)));
  }

  public get(queryParams?:any): Observable<T[]> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/`, typeof queryParams !== 'undefined'? {queryStringParameters: queryParams} : {})     
      )
      .pipe<T[]>(map(result => result.resource))
      .pipe(map((result) => Array.isArray(result) ?  result.map((i) => new this.tConstructor(i)):[]) );
  }

  public getOne(queryParams?:any): Observable<T> {
    return from(this.api
      .get('route-api', `${this.apiUrl}`, typeof queryParams !== 'undefined'? {queryStringParameters: queryParams} : {}))
      .pipe<T>(map(result => new this.tConstructor(result.resource)));
  }
 
  public getById(id: string): Observable<T> {
    return from(this.api
      .get('route-api', `${this.apiUrl}/${id}`, {}))    
      .pipe<T>(map(result => result.resource))
      .pipe(map((result) => new this.tConstructor(result)));
  }

  public update(resource: Partial<T> & { toJson: () => T }): Observable<T> {
    return from(this.api
      .put('route-api', `${this.apiUrl}/${resource._id}`, {body: resource.toJson()}))
      .pipe(map((result) => new this.tConstructor(result)));
  }

  public delete(id: number): Observable<void> {
    return  from(this.api
      .del('route-api', `${this.apiUrl}/${id}`, {}));
  }
}
